var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all"},[_c('Campaign',{attrs:{"data":_vm.campaign,"onSubmit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }